// dudu测试接口
import request from '@/axios'

/**
 * 关闭设备接口
 */
export function closeDudu(data) {
  return request({
    url: '/inside/badge/close',
    data
  })
}

/**
 * 启动设备接口
 */
export function startDudu(data) {
  return request({
    url: '/inside/badge/start',
    data
  })
}

/**
 * 白名单列
 */
export function allowList(data) {
  return request({
    url: '/inside/badge/allowList',
    data
  })
}
